import { useEffect } from "react";
import { useAppContext } from "../config/AppContext";

const loginAs = async (uid, token, prefix, adminId = null) => {
  // Define the endpoint URL
  const url = prefix + "auth/login_as";

  // Define the request body
  const body = JSON.stringify({
    uid: uid,
  });
  if (adminId) {
    localStorage.setItem("lastToken", token);
    localStorage.setItem("lastId", adminId);
  }
  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: body,
    });

    // Check if the request was successful
    if (response.ok) {
      // Decode the response body
      const jsonResponse = await response.json();

      // Extract the token from the response
      const ddString = jsonResponse["token"];
      return ddString;
    } else {
      // Handle error response
      console.error(
        `Failed to log in user: ${response.status} - ${await response.text()}`
      );
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default loginAs;
